var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(0.81 -0.025)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "eli",
    cx: 20.5,
    cy: 20,
    rx: 20.5,
    ry: 20,
    transform: "translate(-0.81 0.025)",
    fill: "#f3f2f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Decorative_icon",
    "data-name": "Decorative icon",
    transform: "translate(9.953 10.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Placement_Area",
    "data-name": "Placement Area",
    transform: "translate(0 0)",
    fill: "#2c2c2c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.271,
    height: 18.529,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18.271,
    height: 17.529,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "#2c2c2c",
    stroke: "#6e6e6e",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.271,
    height: 18.556,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18.271,
    height: 17.556,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "line",
    d: "M9.163,18.082A2.339,2.339,0,0,0,11.325,16H7A2.339,2.339,0,0,0,9.163,18.082Z",
    transform: "translate(0.458 1.189)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-2",
    "data-name": "line",
    d: "M14.513,5.886c0-1.789-1.733-2.546-3.862-2.743V1.521A.576.576,0,0,0,10.033,1H9.106a.576.576,0,0,0-.618.521V3.143c-2.129.2-3.862.953-3.862,2.743C4.626,13.911,2,13.553,2,14.616v.961H17.139v-.961C17.139,13.495,14.513,13.911,14.513,5.886Z",
    transform: "translate(0.051 0.57)",
    fill: "#2c2c2c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.29ef7d047e5abc0870176907054391df.svg";
export { ForwardRef as ReactComponent };